'use client';

import React from 'react';
import { CouponProvider } from '../../contexts/coupon.context';
import type { DisplayLocation } from '../../../../types/marketing.graphql';

export const withCouponProvider = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
    const WithCouponProvider = (props: P & { displayLocation?: DisplayLocation }) => {
        const { displayLocation, ...rest } = props;
        return (
            <CouponProvider displayLocation={displayLocation}>
                <WrappedComponent {...(rest as P)} />
            </CouponProvider>
        );
    };
    WithCouponProvider.displayName = `withCouponProvider(${WrappedComponent.displayName ?? WrappedComponent.name ?? 'Component'})`;
    return WithCouponProvider;
};
